<template>
  <hm-content title="">
    <div class="table-panel flex flex-between">
      <el-button type="primary" size="small" @click="addStoreExpress"
        >添加快递配送</el-button
      >
    </div>
    <el-table
      :data="storeExpressList.records"
      stripe
      border
      lazy
      style="width: 100%"
      size="small"
    >
      <el-table-column
        header-align="center"
        align="center"
        type="index"
        label="编号"
        :index="index => index + (currentPage - 1) * pageSize + 1"
      ></el-table-column>
      <el-table-column
        prop="expressName"
        label="快递配送名称"
        header-align="center"
        align="center"
      >
      </el-table-column>

      <el-table-column
        prop="feeCalcMode"
        label="费用计算方式"
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.feeCalcMode === 'number'">按商品件数计算</span>
          <span v-else>按重量计算</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="lowerLimitAmount"
        label="首件/首重费用"
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">
          <span
            >首{{ scope.row.lowerLimitNumber
            }}{{ scope.row.feeCalcMode === "number" ? "件" : "kg" }},邮费{{
              scope.row.lowerLimitExpressyFee
            }}元</span
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="overPerPrice"
        label="续重/续件费用"
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">
          <span
            >续重每1{{
              scope.row.feeCalcMode === "number" ? "件" : "kg"
            }},加邮费{{ scope.row.overPerPrice }}元</span
          >
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="lowerLimitAmount"
        label="起送价"
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">
          <span>满{{ scope.row.lowerLimitAmount }}元起送</span>
        </template>
      </el-table-column> -->
      <el-table-column
        prop="freeShipAmount"
        label="满额免邮"
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">
          <span>满{{ scope.row.freeShipAmount }}元包邮</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="enabledState"
        label="开启状态"
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">
          <span
            :class="scope.row.enabledState === 'yes' ? 'success' : 'danger'"
            >{{ scope.row.enabledState === "yes" ? "开启" : "关闭" }}</span
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="seqNum"
        label="排序"
        header-align="center"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="freeShipAmount"
        label="配送范围"
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">
          <button class="pointer mr10 no-bg" @click="toDetails(scope.row)">
            <span class="blue">查看</span>
          </button>
        </template>
      </el-table-column>

      <el-table-column label="操作" header-align="center" align="center">
        <template slot-scope="scope">
          <div class="flex flex-center">
            <el-tooltip
              class="item"
              effect="light"
              content="编辑"
              placement="top"
            >
              <button class="pointer mr10 no-bg" @click="edit(scope.row)">
                <span class="hmicon icon-bianji blue"></span>
              </button>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="storeExpressList.total"
        @current-change="paging"
        @size-change="handleSizeChange"
        :page-sizes="[10, 50, 100, 200]"
        layout="total,  prev, pager, next, jumper, sizes"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="dialogVisible"
    >
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="110px"
      >
        <el-form-item label="配送名称" prop="expressName">
          <el-input
            clearable
            v-model="ruleForm.expressName"
            size="small"
            placeholder="请输入配送名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="seqNum">
          <el-input
            type="number"
            @mousewheel.prevent.native
            clearable
            @input="filterGt0('seqNum')"
            v-model="ruleForm.seqNum"
            size="small"
            placeholder="请输入排序值"
          ></el-input>
          <span>排序值影响手机端的显示顺序，数字越小越靠前</span>
        </el-form-item>
        <el-form-item
          label="费用计算方式"
          prop="feeCalcMode"
          v-if="feeCalcModeList2.length > 0"
        >
          <el-radio-group
            v-model="ruleForm.feeCalcMode"
            @change="feeCalcModeChange"
          >
            <el-radio
              v-for="(item, i) in feeCalcModeList2"
              :label="item.itemValue"
              :key="i"
              >{{ item.itemText }}</el-radio
            >
          </el-radio-group>
          <!-- 按重量计算 -->
          <div v-if="costType === 'weight'">
            首<el-input
              type="number"
              @mousewheel.prevent.native
              clearable
              style="width:100px;"
              v-model="ruleForm.lowerLimitNumber"
              @input="filterGt0OrFixed2('lowerLimitNumber')"
              size="small"
            ></el-input
            >KG,邮费<el-input
              clearable
              type="number"
              @mousewheel.prevent.native
              style="width:100px;"
              v-model="ruleForm.lowerLimitExpressyFee"
              @input="filterGt0OrFixed2('lowerLimitExpressyFee')"
              size="small"
            ></el-input>
            <div>
              超出部分,每KG邮费<el-input
                clearable
                type="number"
                @mousewheel.prevent.native
                style="width:100px;"
                v-model="ruleForm.overPerPrice"
                @input="filterGt0OrFixed2('overPerPrice')"
                size="small"
              ></el-input>
            </div>
            <div>
              <!-- 满<el-input
                clearable
                type="number"
                @mousewheel.prevent.native
                style="width:100px;"
                v-model="ruleForm.lowerLimitAmount"
                @input="filterGt0OrFixed2('lowerLimitAmount')"
                size="small"
              ></el-input
              >元起送, -->
              满<el-input
                clearable
                type="number"
                @mousewheel.prevent.native
                style="width:100px;"
                v-model="ruleForm.freeShipAmount"
                @input="filterGt0OrFixed2('freeShipAmount')"
                size="small"
              ></el-input
              >元包邮
            </div>
          </div>
          <!-- 按件数收费 -->
          <div v-if="costType === 'number'">
            首<el-input
              clearable
              type="number"
              @mousewheel.prevent.native
              style="width:100px;"
              v-model="ruleForm.lowerLimitNumber"
              @input="filterGt0('lowerLimitNumber')"
              size="small"
            ></el-input
            >件,邮费<el-input
              clearable
              type="number"
              @mousewheel.prevent.native
              style="width:100px;"
              v-model="ruleForm.lowerLimitExpressyFee"
              @input="filterGt0OrFixed2('lowerLimitExpressyFee')"
              size="small"
            ></el-input>
            <div>
              超出部分,每件邮费<el-input
                clearable
                type="number"
                @mousewheel.prevent.native
                style="width:100px;"
                v-model="ruleForm.overPerPrice"
                @input="filterGt0OrFixed2('overPerPrice')"
                size="small"
              ></el-input>
            </div>
            <div>
              <!-- 满<el-input
                clearable
                type="number"
                @mousewheel.prevent.native
                style="width:100px;"
                v-model="ruleForm.lowerLimitAmount"
                @input="filterGt0OrFixed2('lowerLimitAmount')"
                size="small"
              ></el-input
              >元起送, -->
              满<el-input
                clearable
                type="number"
                @mousewheel.prevent.native
                style="width:100px;"
                v-model="ruleForm.freeShipAmount"
                @input="filterGt0OrFixed2('freeShipAmount')"
                size="small"
              ></el-input
              >元包邮
            </div>
          </div>
        </el-form-item>

        <el-form-item label="是否启用" prop="enabledState">
          <el-switch
            :disabled="disabled"
            v-model="ruleForm.enabledState"
            active-color="#2d8"
            active-text="开启"
            inactive-text="关闭"
            active-value="yes"
            inactive-value="no"
          ></el-switch>
        </el-form-item>
        <el-form-item label="配送范围" prop="areaCodeRegion">
          <el-button
            :disabled="disabled"
            type="primary"
            size="small"
            @click="openAuthorizeDialog"
            >选择配送范围</el-button
          >
        </el-form-item>
        <!-- <div class="area-style flex flex-wrap">
          <el-tree
            empty-text="暂无权限"
            class="tree-style flex-1 flex-center"
            :props="props"
            node-key="value"
            ref="tree"
            :load="loadNode1"
            lazy
            highlight-current
            show-checkbox
          ></el-tree>
          <el-tree
            empty-text="暂无权限"
            class="tree-style flex-1 flex-center"
            :props="props"
            node-key="value"
            ref="tree"
            :load="loadNode2"
            lazy
            highlight-current
            show-checkbox
          ></el-tree>
          <el-tree
            empty-text="暂无权限"
            class="tree-style flex-1 flex-center"
            :props="props"
            node-key="value"
            ref="tree"
            :load="loadNode3"
            lazy
            highlight-current
            show-checkbox
          ></el-tree>
        </div> -->
        <div class="flex flex-center">
          <el-button
            :disabled="disabled"
            type="primary"
            size="small"
            @click="submitForm('ruleForm')"
            >保存</el-button
          >
          <el-button size="small" @click="dialogVisible = false"
            >关闭</el-button
          >
        </div>
      </el-form>
    </el-dialog>
    <el-drawer
      custom-class="hm-drawer"
      :wrapperClosable="false"
      title="选择配送范围"
      :visible="authorizeDialogVisible"
      direction="rtl"
      :before-close="handleClose"
    >
      <div class="drawer-content">
        <div class="caption">所有的配送范围：</div>
        <el-tree
          empty-text="暂无权限"
          :props="props"
          node-key="value"
          ref="tree"
          :load="loadNode"
          lazy
          highlight-current
          show-checkbox
        ></el-tree>
      </div>
      <div class="drawer-footer flex flex-between item-center">
        <div>
          <el-dropdown trigger="click" @command="selectItem">
            <span class="el-dropdown-link flex item-center">
              树操作
              <i class="el-icon-arrow-up el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="checkAll">全部勾选</el-dropdown-item>
              <el-dropdown-item command="cancleCheckAll"
                >取消全选</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div>
          <el-button type="primary" size="small" @click="savePermission"
            >保存</el-button
          >
          <el-button size="small" @click="authorizeDialogVisible = false"
            >返回</el-button
          >
        </div>
      </div>
    </el-drawer>
    <!-- <hm-transfer-city
      queryIsUsed
      showUseable
      ref="ruleTransfer"
      showAttribute
      :leftOption="leftRules"
    ></hm-transfer-city> -->
    <el-dialog
      :close-on-click-modal="false"
      title="配送范围"
      :visible.sync="dialogVisibleAdress"
    >
      <div class="table-panel flex flex-end">
        <div>
          <el-input
            clearable
            style="width:250px"
            v-model.trim="keyWords"
            placeholder="请输入省/市/区"
            size="small"
            class="ipt mr10"
          ></el-input>
          <el-button type="primary" size="small" @click="search"
            >查询</el-button
          >
        </div>
      </div>
      <el-table
        :data="detailsAdres.records"
        stripe
        border
        lazy
        style="width: 100%"
        size="small"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="编号"
          :index="index => index + (currentPageAdress - 1) * pageSizeAdress + 1"
        ></el-table-column>
        <el-table-column
          prop="provinceName"
          label="省"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="cityName"
          label="市"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.cityName ? scope.row.cityName : "全市" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="districtName"
          label="区"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{
              scope.row.districtName ? scope.row.districtName : "全区"
            }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="detailsAdres.total"
          @current-change="pagingAdress"
          @size-change="handleSizeChangeAdress"
          :page-sizes="[10, 50, 100, 200]"
          layout="total,  prev, pager, next, jumper, sizes"
          :current-page="currentPageAdress"
        ></el-pagination>
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
import area from "@/utils/area";

export default {
  components: {},
  data() {
    const patternAreaCodeRegionFunc = function(rule, val, callback) {
      if (!this.ruleForm.areaCodeRegion.length > 0) {
        return callback(new Error("请选择配送范围"));
      }
      callback();
    }.bind(this);
    const patternPointsRatioFunc = function(rule, val, callback) {
      if (val === "number") {
        if (
          !this.ruleForm.lowerLimitNumber ||
          !this.ruleForm.lowerLimitExpressyFee ||
          !this.ruleForm.overPerPrice ||
          // !this.ruleForm.lowerLimitAmount ||
          !this.ruleForm.freeShipAmount
        ) {
          return callback(new Error("请填写所有项"));
        }
      } else if (val === "weight") {
        if (
          !this.ruleForm.lowerLimitNumber ||
          !this.ruleForm.lowerLimitExpressyFee ||
          !this.ruleForm.overPerPrice ||
          // !this.ruleForm.lowerLimitAmount ||
          !this.ruleForm.freeShipAmount
        ) {
          return callback(new Error("请填写所有项"));
        }
      }

      callback();
    }.bind(this);
    return {
      keyWords: "",
      title: "",
      area,
      data: [],
      disabled: false,
      pageSize: 10,
      currentPage: 1,
      pageSizeAdress: 10,
      currentPageAdress: 1,
      dialogVisible: false,
      authorizeDialogVisible: false,
      dialogVisibleAdress: false,
      feeCalcModeList2: [],
      leftRules: [],
      expressId: "",
      ruleForm: {
        seqNum: "",
        lowerLimitNumber: "",
        expressMode: "",
        expressName: "",
        feeCalcMode: "",
        lowerLimitAmount: "",
        expressFee: "",
        freeShipAmount: "",
        baseDistanceUpperLimit: "",
        overPerkmPrice: "",
        baseWeightUpperLimit: "",
        overPerkgPrice: "",
        areaCodeRange: "yes",
        enabledState: "no",
        lowerLimitExpressyFee: "",
        overPerPrice: "",
        areaCodeRegion: []
      },
      rules: {
        expressMode: [
          {
            required: true,
            message: "请选择配送方式",
            trigger: "blur"
          }
        ],
        expressName: [
          {
            required: true,
            message: "请填写配送名称",
            trigger: "blur"
          },
          {
            max: 20,
            message: "名称应小于20个字",
            trigger: "blur"
          }
        ],
        feeCalcMode: [
          {
            required: true,
            message: "请选择费用计算方式",
            trigger: "blur"
          },
          {
            required: true,
            validator: patternPointsRatioFunc,
            trigger: "blur"
          }
        ],
        areaCodeRange: [
          {
            required: true,
            // message: "请选择费用计算方式",
            trigger: "blur"
          }
        ],
        areaCodeRegion: [
          {
            required: true,
            validator: patternAreaCodeRegionFunc,
            trigger: "blur"
          }
        ]
      },
      costType: "",
      props: {
        isLeaf: "leaf",
        label: "label",
        children: "children"
      }
    };
  },
  computed: mapGetters(["storeExpressList", "cityList", "detailsAdres"]),
  watch: {
    "ruleForm.feeCalcMode": {
      handler(val) {
        if (val) {
          this.costType = val;
        }
      },
      deep: true
    }
  },
  created() {},
  mounted() {
    this.queryList();
    this.queryCityList();
    this.queryFeeCalcModeList2();
  },
  methods: {
    queryList() {
      this.$store.dispatch("queryStoreExpressList", {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      });
    },
    queryAddressList() {
      this.$store.dispatch("detailsAddress", {
        expressId: this.expressId,
        pageNo: this.currentPageAdress,
        pageSize: this.pageSizeAdress,
        keyWords: this.keyWords
      });
    },
    search() {
      this.currentPageAdress = 1;
      this.queryAddressList();
    },
    // 过滤大于0且如果是小数保留两位
    filterGt0OrFixed2(prop) {
      // this[prop] = this[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (this.ruleForm[prop].indexOf(".") < 0 && this.ruleForm[prop] != "") {
        //首位是0的话去掉
        this.ruleForm[prop] = parseFloat(this.ruleForm[prop]);
      }
    },
    // 过滤大于0
    filterGt0(prop) {
      if (this.ruleForm[prop].length == 1) {
        this.ruleForm[prop] = this.ruleForm[prop].replace(/[^0-9]/g, "");
      } else {
        this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)|\D/g, "");
      }
    },
    loadNode1(node, resolve) {
      // // 一级节点处理
      if (node.level === 0) {
        this.$store
          .dispatch("queryRegionCode")
          .then(res => {
            this.data = res.result;

            let list = [];
            for (let i = 0; i < 10; i++) {
              list.push(this.data[i]);
            }
            resolve(list);
          })
          .catch(err => {
            throw new Error(err);
          });
      }
      // 其余节点处理
      if (node.level >= 1 && node.level <= 2) {
        // 注意！把resolve传到你自己的异步中去

        this.getIndex(node, resolve);
      } else {
        return resolve([]);
      }
    },
    loadNode2(node, resolve) {
      // // 一级节点处理
      if (node.level === 0) {
        this.$store
          .dispatch("queryRegionCode")
          .then(res => {
            this.data = res.result;

            let list = [];
            for (let i = 10; i < 20; i++) {
              list.push(this.data[i]);
            }
            resolve(list);
          })
          .catch(err => {
            throw new Error(err);
          });
      }
      // 其余节点处理
      if (node.level >= 1 && node.level <= 2) {
        // 注意！把resolve传到你自己的异步中去

        this.getIndex(node, resolve);
      } else {
        return resolve([]);
      }
    },
    loadNode3(node, resolve) {
      // // 一级节点处理
      if (node.level === 0) {
        this.$store
          .dispatch("queryRegionCode")
          .then(res => {
            this.data = res.result;

            let list = [];
            for (let i = 20; i < res.result.length; i++) {
              list.push(this.data[i]);
            }
            resolve(list);
          })
          .catch(err => {
            throw new Error(err);
          });
      }
      // 其余节点处理
      if (node.level >= 1 && node.level <= 2) {
        // 注意！把resolve传到你自己的异步中去

        this.getIndex(node, resolve);
      } else {
        return resolve([]);
      }
    },
    loadNode(node, resolve) {
      // // 一级节点处理

      if (node.level === 0) {
        this.requestTree(resolve);
      }
      // 其余节点处理
      if (node.level >= 1 && node.level <= 2) {
        // 注意！把resolve传到你自己的异步中去

        this.getIndex(node, resolve);
      } else {
        return resolve([]);
      }
    },
    // 首次加载一级节点数据函数
    requestTree(resolve) {
      this.$store
        .dispatch("queryRegionCode")
        .then(res => {
          this.data = res.result;

          let list = [];
          for (let i = 0; i < 10; i++) {
            list.push(this.data[i]);
          }

          // data.forEach(v => {
          //   v.attrId = v.id;
          //   v.attrValue = v.name;
          //   v.attrType = "category";
          // });
          resolve(this.data);
        })
        .catch(err => {
          throw new Error(err);
        });
    },
    // 异步加载叶子节点数据函数
    getIndex(node, resolve) {
      if (node.level < 3) {
        this.$store
          .dispatch("queryRegionCode", {
            value: node.data.value,
            level: node.level
          })
          .then(res => {
            const data = res.result;

            data.forEach(v => {
              v.leaf = v.level === "3" ? true : false;
            });
            resolve(data);
          })
          .catch(err => {
            throw new Error(err);
          });
      }
    },
    queryCityList() {
      return this.$store.dispatch("queryRegionCode");
    },
    queryExpressModeList() {
      this.$store.dispatch("queryExpressModeList");
    },
    queryFeeCalcModeList2() {
      return this.$store.dispatch("queryFeeCalcModeList2").then(res => {
        this.feeCalcModeList2 = res.result;
      });
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    pagingAdress(page) {
      this.currentPageAdress = page;
      this.queryAddressList();
    },
    handleSizeChangeAdress(size) {
      this.currentPageAdress = 1;
      this.pageSizeAdress = size;
      this.queryAddressList();
    },
    toDetails(row) {
      // row.areaCodeRegion = row.areaCodeRegion.split(",");
      this.dialogVisibleAdress = true;
      this.expressId = row.expressId;
      this.queryAddressList();

      // this.title = "查看详情";
      // this.disabled = true;
      // this.dialogVisible = true;
      // setTimeout(() => {
      //   this.init();
      // }, 0);
      // let params = {
      //   localExpressId: row.localExpressId
      // };
      // this.$store.dispatch("detailsExpress", params).then(res => {
      //   if (res.code === "0") {
      //     for (let key in res.result) {
      //       this.ruleForm[key] = res.result[key];
      //     }
      //     this.init(this.ruleForm.areaCodeCenter, this.ruleForm.areaCodeRadius);
      //   }
      // });
    },
    edit(row) {
      this.title = "编辑详情";
      this.dialogVisible = true;

      let params = {
        expressId: row.expressId
      };
      this.$store.dispatch("detailsStoreExpress", params).then(res => {
        if (res.code === "0") {
          for (let key in res.result) {
            this.ruleForm[key] = res.result[key];
          }
        }
      });
    },
    addStoreExpress() {
      this.title = "添加快递配送";
      this.dialogVisible = true;
      setTimeout(() => {
        this.resetRuleForm();
      }, 0);
    },
    feeCalcModeChange(val) {
      this.costType = val;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = this.ruleForm;

          this.$store
            .dispatch(
              this.title === "添加快递配送"
                ? "saveStoreExpressConfig"
                : "editStoreExpress",
              params
            )
            .then(res => {
              if (res.code === "0") {
                this.dialogVisible = false;
                this.queryList();
              }
            });
        } else {
          return false;
        }
      });
    },
    handleClose() {
      this.authorizeDialogVisible = false;
    },
    openAuthorizeDialog() {
      this.authorizeDialogVisible = true;
      setTimeout(() => {
        this.$refs.tree.setCheckedKeys(this.ruleForm.areaCodeRegion);
      }, 0);
    },
    selectItem(e) {
      let expand = false;

      switch (e) {
        case "checkAll":
          this.$refs.tree.setCheckedNodes(this.data);
          break;
        case "cancleCheckAll":
          this.$refs.tree.setCheckedNodes([]);
          break;
        case "openAll":
          expand = true;
          break;
        case "cancleOpenAll":
          expand = false;
          break;
        default:
          break;
      }
      for (let i = 0; i < this.$refs.tree.store._getAllNodes().length; i++) {
        this.$refs.tree.store._getAllNodes()[i].expanded = expand;
      }
    },
    savePermission() {
      this.ruleForm.areaCodeRegion = this.$refs.tree
        .getCheckedNodes()
        .map(v => v.value);
      this.authorizeDialogVisible = false;
    },
    resetRuleForm() {
      this.$refs.ruleForm.resetFields();
      this.ruleForm.feeCalcMode = "";
      this.ruleForm.lowerLimitAmount = "";
      this.ruleForm.expressFee = "";
      this.ruleForm.freeShipAmount = "";
      this.ruleForm.lowerLimitNumber = "";
      this.ruleForm.overPerkmPrice = "";
      this.ruleForm.baseWeightUpperLimit = "";
      this.ruleForm.overPerkgPrice = "";
      this.ruleForm.areaCodeRange = "yes";
      this.ruleForm.enabledState = "";
      this.ruleForm.lowerLimitExpressyFee = "";
      this.ruleForm.overPerPrice = "";
      this.ruleForm.seqNum = "";
      this.keyWords = "";
    }
  }
};
</script>
<style lang="scss">
.area-style {
  height: 300px;
  overflow-y: auto;
  // .el-tree-node__content {
  //   width: 200px;
  //   float: left;
  // }
  .tree-style
    .el-tree-node__children
    .el-tree-node__children
    .el-tree-node__content {
    float: left;
  }
}
</style>
<style lang="scss" scoped></style>
